export default __webpack_public_path__ + "static/media/IL.369d5e29.svg";